import Layout from '../views/layout/index.vue'
import i18n from '@/lang'
import { hasPermission } from '../plugins/permission-manager/manager'
import { PermissionKey } from '@pt/enums/user'
import { routerItem } from '@pt/views/layout/aside/type'

const children: routerItem['children'] = [
  {
    path: 'overview',
    name: 'dashboard.overview',
    meta: {
      title: i18n.t('playTurbo.dashboard.overview.title'),
      defaultPath: '/dashboard/overview',
      keys: [PermissionKey.Insights],
      payment: 'free',
    },
    component: () => import('@pt/views/dashboard/overview/index.vue'),
  },
  {
    path: 'material',
    name: 'dashboard.material',
    meta: {
      title: i18n.t('playTurbo.dashboard.material.title'),
      defaultPath: '/dashboard/material',
      keys: [PermissionKey.Insights],
      payment: 'free',
    },
    component: () => import('@pt/views/dashboard/material/index.vue'),
  },
  {
    path: 'material/detail',
    name: 'dashboard.material.detail',
    meta: {
      title: i18n.t('playTurbo.dashboard.material.detailTitle'),
      defaultPath: '/dashboard/material/detail',
      keys: [PermissionKey.Insights],
      payment: 'free',
    },
    component: () => import('@pt/views/dashboard/material/detail/index.vue'),
  },
]

const route: routerItem = {
  path: '/dashboard',
  component: Layout,
  redirect: () => {
    const target =
      children.find((item) => hasPermission(item.meta?.keys ?? [], 'or')) ||
      children[0]
    return { name: target?.name }
  },
  name: 'dashboard',
  icon: 'data_insights',
  meta: {
    title: i18n.t('playTurbo.dashboard.title'),
    keys: [PermissionKey.Insights],
  },
  hidden: () => {
    return !hasPermission([PermissionKey.Insights], 'or')
  },
  children,
}

export default route
